// extracted by mini-css-extract-plugin
module.exports = {"spaceBetween":"style__spaceBetween__0elw6","marginBottom":"style__marginBottom__nliNo"};